import { render, staticRenderFns } from "./FjSidebar.vue?vue&type=template&id=b6e6a00c&scoped=true&"
import script from "./FjSidebar.vue?vue&type=script&lang=js&"
export * from "./FjSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FjSidebar.vue?vue&type=style&index=0&id=b6e6a00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e6a00c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
